import { httpClient } from '../../../net/httpClient';
import UrlConfig from '../../../net/UrlConfig';

import {
  ON_CPT_QUERY_INPUT_CHANGE,
  START_LOAD_CPT_EMPLOYEE_OPTIONS,
  LOAD_CPT_EMPLOYEE_OPTIONS_SUCCESS,
  LOAD_CPT_EMPLOYEE_OPTIONS_FAILURE,
  INIT_LOAD_CPT_EMPLOYEE_OPTIONS_ACTION_STATUS,
  START_LOAD_CPT_INFO,
  LOAD_CPT_INFO_SUCCESS,
  LOAD_CPT_INFO_FAILURE,
  INIT_LOAD_CPT_INFO_ACTION_STATUS,
  SELECT_CPT_INFO,
  OPEN_ADD_OR_EDIT_CPT_MODAL,
  ADD_OR_EDIT_CPT_CHANGE_INPUT,
  START_ADD_OR_EDIT_CPT,
  ADD_OR_EDIT_CPT_SUCCESS,
  ADD_OR_EDIT_CPT_FAILURE,
  INIT_ADD_OR_EDIT_CPT_ACTION_STATUS,
  RESET_ADD_OR_EDIT_CPT_MODAL,
  START_SUBMIT_CPT_APPROVAL,
  SUBMIT_CPT_APPROVAL_SUCCESS,
  SUBMIT_CPT_APPROVAL_FAILURE,
  INIT_SUBMIT_CPT_APPROVAL_ACTION_STATUS,
  OPEN_DEL_CPT_MODAL,
  START_DEL_CPT,
  DEL_CPT_SUCCESS,
  DEL_CPT_FAILURE,
  INIT_DEL_CPT_ACTION_STATUS,
  RESET_DEL_CPT_MODAL,
  CPT_NOTE_CHANGE_INPUT,
  START_LOAD_CPT_NOTE,
  LOAD_CPT_NOTE_SUCCESS,
  LOAD_CPT_NOTE_FAILURE,
  INIT_LOAD_CPT_NOTE_ACTION_STATUS,
  START_ADD_OR_EDIT_CPT_NOTE,
  ADD_OR_EDIT_CPT_NOTE_SUCCESS,
  ADD_OR_EDIT_CPT_NOTE_FAILURE,
  INIT_ADD_OR_EDIT_CPT_NOTE_ACTION_STATUS,
  RESET_CPT_NOTE_MODAL,
} from './CptConstants';

export function onCptQueryInputChange({ name, value }) {
  return {
    type: ON_CPT_QUERY_INPUT_CHANGE,
    payload: { name, value },
  };
}

function startLoadCptEmployeeOptions() {
  return {
    type: START_LOAD_CPT_EMPLOYEE_OPTIONS,
  };
}

export function loadCptEmployeeOptions(namePart = '') {
  return function(dispatch) {
    dispatch(startLoadCptEmployeeOptions());
    httpClient
      .get(UrlConfig.QUERY_CPT_EMPLOYEE_OPTIONS, { namePart })
      .then(resp => dispatch(loadCptEmployeeOptionsSuccess(resp)))
      .catch(err => dispatch(loadCptEmployeeOptionsFailure(err)));
  };
}

function loadCptEmployeeOptionsSuccess(resp) {
  return {
    type: LOAD_CPT_EMPLOYEE_OPTIONS_SUCCESS,
    payload: resp,
  };
}

function loadCptEmployeeOptionsFailure(err) {
  return {
    type: LOAD_CPT_EMPLOYEE_OPTIONS_FAILURE,
    payload: err,
  };
}

export function initLoadCptEmployeeOptionsActionStatus() {
  return {
    type: INIT_LOAD_CPT_EMPLOYEE_OPTIONS_ACTION_STATUS,
  };
}

function startLoadCptInfo() {
  return {
    type: START_LOAD_CPT_INFO,
  };
}

export function loadCptInfo(params) {
  return function(dispatch) {
    dispatch(startLoadCptInfo());
    httpClient
      .get(UrlConfig.QUERY_CPT_LIST, params)
      .then(resp => dispatch(loadCptInfoSuccess(resp)))
      .catch(err => dispatch(loadCptInfoFailure(err)));
  };
}

function loadCptInfoSuccess(resp) {
  return {
    type: LOAD_CPT_INFO_SUCCESS,
    payload: resp,
  };
}

function loadCptInfoFailure(err) {
  return {
    type: LOAD_CPT_INFO_FAILURE,
    payload: err,
  };
}

export function initLoadCptInfoActionStatus() {
  return {
    type: INIT_LOAD_CPT_INFO_ACTION_STATUS,
  };
}

export function selectCptInfo(array) {
  return {
    type: SELECT_CPT_INFO,
    payload: array,
  };
}

export function openAddOrEditCptModal(mode, data) {
  return {
    type: OPEN_ADD_OR_EDIT_CPT_MODAL,
    payload: { mode, data },
  };
}

export function addOrEditCptChangeInput({ name, value }) {
  return {
    type: ADD_OR_EDIT_CPT_CHANGE_INPUT,
    payload: { name, value },
  };
}

function startAddOrEditCpt() {
  return {
    type: START_ADD_OR_EDIT_CPT,
  };
}

export function addOrEditCpt(params) {
  return function(dispatch) {
    dispatch(startAddOrEditCpt());
    httpClient
      .post(UrlConfig.ADD_OR_EDIT_CPT, params)
      .then(resp => dispatch(addOrEditCptSuccess(resp)))
      .catch(err => dispatch(addOrEditCptFailure(err)));
  };
}

function addOrEditCptSuccess(resp) {
  return {
    type: ADD_OR_EDIT_CPT_SUCCESS,
    payload: resp,
  };
}

function addOrEditCptFailure(err) {
  return {
    type: ADD_OR_EDIT_CPT_FAILURE,
    payload: err,
  };
}

export function initAddOrEditCptActionStatus() {
  return {
    type: INIT_ADD_OR_EDIT_CPT_ACTION_STATUS,
  };
}

export function resetAddOrEditCptModal() {
  return {
    type: RESET_ADD_OR_EDIT_CPT_MODAL,
  };
}

function startSubmitCptApproval() {
  return {
    type: START_SUBMIT_CPT_APPROVAL,
  };
}

export function submitCptApproval(params, actionType) {
  let url = UrlConfig.APPROVE_CPT;
  if (actionType === 'APPROVE') {
    url = UrlConfig.APPROVE_CPT;
  } else if (actionType === 'REJECT') {
    url = UrlConfig.REJECT_CPT;
  }

  return function(dispatch) {
    dispatch(startSubmitCptApproval());
    httpClient
      .post(url, params)
      .then(resp => dispatch(submitCptApprovalSuccess(resp)))
      .catch(err => dispatch(submitCptApprovalFailure(err)));
  };
}

function submitCptApprovalSuccess(resp) {
  return {
    type: SUBMIT_CPT_APPROVAL_SUCCESS,
    payload: resp,
  };
}

function submitCptApprovalFailure(err) {
  return {
    type: SUBMIT_CPT_APPROVAL_FAILURE,
    payload: err,
  };
}

export function initSubmitCptApprovalActionStatus() {
  return {
    type: INIT_SUBMIT_CPT_APPROVAL_ACTION_STATUS,
  };
}

export function openDelCptModal(data) {
  return {
    type: OPEN_DEL_CPT_MODAL,
    payload: data,
  };
}

function startDelCpt() {
  return {
    type: START_DEL_CPT,
  };
}

export function delCpt(params) {
  return function(dispatch) {
    dispatch(startDelCpt());
    httpClient
      .post(UrlConfig.DELETE_CPT, params)
      .then(resp => dispatch(delCptSuccess(resp)))
      .catch(err => dispatch(delCptFailure(err)));
  };
}

function delCptSuccess(resp) {
  return {
    type: DEL_CPT_SUCCESS,
    payload: resp,
  };
}

function delCptFailure(err) {
  return {
    type: DEL_CPT_FAILURE,
    payload: err,
  };
}

export function initDelCptActionStatus() {
  return {
    type: INIT_DEL_CPT_ACTION_STATUS,
  };
}

export function resetDelCptModal() {
  return {
    type: RESET_DEL_CPT_MODAL,
  };
}

export function cptNoteChangeInput({ name, value }) {
  return {
    type: CPT_NOTE_CHANGE_INPUT,
    payload: { name, value },
  };
}

function startLoadCptNote() {
  return {
    type: START_LOAD_CPT_NOTE,
  };
}

export function loadCptNote() {
  return function(dispatch) {
    dispatch(startLoadCptNote());
    httpClient
      .get(UrlConfig.QUERY_CPT_NOTE_LIST)
      .then(resp => dispatch(loadCptNoteSuccess(resp)))
      .catch(err => dispatch(loadCptNoteFailure(err)));
  };
}

function loadCptNoteSuccess(resp) {
  return {
    type: LOAD_CPT_NOTE_SUCCESS,
    payload: resp,
  };
}

function loadCptNoteFailure(err) {
  return {
    type: LOAD_CPT_NOTE_FAILURE,
    payload: err,
  };
}

export function initLoadCptNoteActionStatus() {
  return {
    type: INIT_LOAD_CPT_NOTE_ACTION_STATUS,
  };
}

function startAddOrEditCptNote() {
  return {
    type: START_ADD_OR_EDIT_CPT_NOTE,
  };
}

export function addOrEditCptNote(params) {
  return function(dispatch) {
    dispatch(startAddOrEditCptNote());
    httpClient
      .post(UrlConfig.ADD_OR_EDIT_CPT_NOTE, params)
      .then(resp => dispatch(addOrEditCptNoteSuccess(resp)))
      .catch(err => dispatch(addOrEditCptNoteFailure(err)));
  };
}

function addOrEditCptNoteSuccess(resp) {
  return {
    type: ADD_OR_EDIT_CPT_NOTE_SUCCESS,
    payload: resp,
  };
}

function addOrEditCptNoteFailure(err) {
  return {
    type: ADD_OR_EDIT_CPT_NOTE_FAILURE,
    payload: err,
  };
}

export function initAddOrEditCptNoteActionStatus() {
  return {
    type: INIT_ADD_OR_EDIT_CPT_NOTE_ACTION_STATUS,
  };
}

export function resetCptNoteModal() {
  return {
    type: RESET_CPT_NOTE_MODAL,
  };
}
